
import { onMounted, toRefs, watch } from "vue";
import { Options, setup, Vue } from 'vue-class-component';
import { useStore } from "vuex";

@Options({})
export default class FileUploadProgress extends Vue {

  progressWrapper = setup(() => {
    const store = useStore();
    const {globalFileProgressVisible, globalFileProgressValue} = toRefs(store.state);

    watch(globalFileProgressVisible, (cur, pre) => {
    })
    watch(globalFileProgressValue, (cur, pre) => {
    })

    onMounted(()=>{

      //console.log("loadingMask mounted",globalLoading);
    })

    return {
      visble: globalFileProgressVisible,
      value: globalFileProgressValue,
    }
  })
}
